import Navigation from './Navigation';
import { mainContentClassName } from '../context/NavContext';

export default function PageLayout({ children }) {
  return (
    <>
      <Navigation />
      <div className={mainContentClassName}>{children}</div>
    </>
  );
}
